import * as system from 'durandal/system';

import { FILE_STORAGE } from '@/config/env';
import { ApiService } from '@/features/api';
import { Instance as companyService } from '@/legacy/services/company';
import * as userService from '@/legacy/services/user';

import { FileStorageDownloadLinkViewModel } from '../types/FileStorageDownloadLinkViewModel';
import { UploadedFileViewModel } from '../types/UploadedFileViewModel';

interface PopupParameters {
  location: number;
  width: number;
  height: number;
  left?: number;
  top?: number;
}

export class FileStorageService {
  private userService: userService.UserService;

  constructor() {
    this.userService = userService.Instance;
  }

  public upload(attachment: FileList): Promise<UploadedFileViewModel> {
    const companyId = companyService.CompanyId();
    const formData = new FormData();
    formData.append('fileName', attachment[0].name);
    formData.append('file', attachment[0]);
    formData.append('companyId', companyId);

    const url = `${FILE_STORAGE.API_BASE_URL}/${FILE_STORAGE.API_VERSION}/upload`;
    return ApiService.post<UploadedFileViewModel>(url, { body: formData });
  }

  public delete(uniqueFileId: string): Promise<boolean> {
    const companyId = companyService.CompanyId();
    const url = `${FILE_STORAGE.API_BASE_URL}/${FILE_STORAGE.API_VERSION}/${companyId}/${uniqueFileId}`;
    return ApiService.remove(url);
  }

  public viewFileStorageFile(viewModel: FileStorageDownloadLinkViewModel) {
    return system
      .defer((dfd) => {
        // default parameter values
        const popupHeight = 650;
        const popupWidth = 800;
        const popupCentered = true;

        // default parameters
        const parameters: PopupParameters = {
          location: 1,
          width: popupWidth,
          height: popupHeight,
        };

        // center pop-up if needed
        if (popupCentered) {
          parameters.left = (window.screen.width - popupWidth) / 2;
          parameters.top = (window.screen.height - popupHeight) / 2;
        }

        const features = $.map(parameters, (value, name) => `${name}=${value}`).join(',');

        // open pop-up without URL first to ensure that pop-up blocker wouldn't prevent it after our delay
        const popup = window.open('', '', features);

        if (popup.document) {
          popup.document.write(
            '<html><head><title>Connecting...</title></head><body></body></html>'
          );
        }

        popup.location.href = `${FILE_STORAGE.API_BASE_URL}/${FILE_STORAGE.API_VERSION}/${viewModel.companyId}/${viewModel.companyFileStorageFileId}/${viewModel.downloadId}`;
      })
      .promise();
  }
}
export const Instance = new FileStorageService();
